export default "__VITE_ASSET__4358026d__"